<template>
  <button-vue
    :is-cta="isCta"
    :href="redirectionURL"
    :use-router="false"
    :class="classes"
    :modifiers="modifiers"
    :is-block="isBlock"
    :copy="buttonText"
    :event-category="eventCategory"
    data-test-id="start-trial-button"
  />
</template>

<script>
import ButtonVue from "@/shared/button"
import { mapGetters } from "vuex"

export default {
  name: "StartTrialButton",
  components: {
    ButtonVue
  },
  props: {
    signupRoute: {
      type: String,
      required: false,
      default: ""
    },
    isCta: {
      type: Boolean,
      default: true
    },
    isBlock: {
      type: Boolean,
      default: true
    },
    modifiers: {
      type: Array,
      default: () => []
    },
    eventCategory: {
      type: String,
      default: "body-20210521-start_free_trial_cta"
    },
    ctaCopy: {
      type: String,
      required: false,
      default: ""
    },
    ctaClass: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters(["hasTrialed", "isUserBasic"]),
    ...mapGetters("layout", ["startTrialButtonCtaHref"]),
    classes() {
      if (this.ctaClass) {
        return this.ctaClass
      }

      return {
        "js-open-signup-popup": !this.redirectionURL
      }
    },
    redirectionURL() {
      if (this.startTrialButtonCtaHref) {
        return this.startTrialButtonCtaHref
      }

      if (this.signupRoute) {
        return this.signupRoute
      }

      if (this.isUserBasic) {
        return "/pricing"
      }

      return ""
    },
    buttonText() {
      if (this.ctaCopy) {
        return this.ctaCopy
      }

      const key = this.hasTrialed ? "subscribeNow" : "freeTrial"

      return this.$t(key)
    }
  },
  i18n: {
    messages: {
      en: {
        freeTrial: "Start your free trial",
        subscribeNow: "Subscribe Now"
      },
      de: {
        freeTrial: "Jetzt kostenlos testen",
        subscribeNow: "Hol dir das Abo"
      },
      es: {
        freeTrial: "Empieza tu prueba gratuita",
        subscribeNow: "Suscríbase ahora"
      }
    }
  }
}
</script>
